import type { ItemsQuery } from "@mondaydotcomorg/api";
import { ALL_MONDAY_SCHEMAS } from "@onesolution/monday";
import { gql } from "graphql-request";
import { formatPaginatedResult } from "../format";
import { requestAndFormat } from "../utils";

export const itemsByPagesQuery = <T>(params: {
	boardId: string;
	columnIds: string[];
	cursor?: string;
	limit?: number;
	queryParams: ItemsQuery;
}) =>
	requestAndFormat(
		{
			defaultParams: {
				limit: 20,
			},
			gql: gql`
                query GetItemsPagesByValues(
                    $boardId: ID!,
                    $columnIds: [String!]!,
                    $limit: Int,
                     ${params.cursor ? "$cursor: String!" : "$queryParams: ItemsQuery"}
                ) {

                    boards(ids: [$boardId]) {
                        items_count
                        
                        items_page(limit: $limit, ${params.cursor ? "cursor: $cursor" : "query_params: $queryParams"}) {
                            cursor
                            items {
                                id
                                name
                                column_values(ids: $columnIds) {
                                    ${ALL_MONDAY_SCHEMAS}

                                    ... on BoardRelationValue {
                                        display_value
                                    }
                                }
                            }
                        }
                    }
                }
                `,
			resultKey: "boards[0].items_page.items",
			additionalFormatting: formatPaginatedResult<T>(
				"boards[0].items_page.cursor",
			),
			outType: {} as {
				cursor: string;
				items: T[];
			},
		},
		params,
	);
